import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LoaderService } from '../../../services/loader.service';
import { FinanceService } from '../finance.service';

@Component({
  selector: 'app-view-champion-incentive',
  templateUrl: './view-champion-incentive.component.html',
  styleUrls: ['./view-champion-incentive.component.css'],
  providers: [FinanceService]
})
export class ViewChampionIncentiveComponent implements OnInit {
  p;
  masterIncentiveMonth;
  headers_res;
  per_page;
  total_page;
  page_limit;
  current_page = 1;
  InsentiveCompletelist;
  InsentivePendinglist;
  monthlyIncentiveListData;
  total_records;
  InsentiveCompletelist_totalPage;
  InsentivePendinglist_totalPage;
  successMessage: string;
  errorMessage: string;
  successalert = false;
  erroralert = false;
  role;
  pendingStatus = 'pending';
  releasedStatus = 'released';
  currentProjectStatus = this.pendingStatus;
  fromDate;
  toDate;
 
  constructor(	private route:ActivatedRoute,
    private financeService:FinanceService,
    private loaderService: LoaderService) { }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
        this.masterIncentiveMonth = params['month'];
        console.log('masterIncentiveMonth',this.masterIncentiveMonth);
      });
      this.currentProjectStatus;
      console.log('currentProjectStatus',this.currentProjectStatus);
      this.getChampionInsentivePaidlist(1, '');
      this.getChampionIncentivePendingList(1,'');
      if(this.currentProjectStatus !== 'pending') {
        this.InsentiveCompletelist;
        console.log('InsentiveCompletelist',this.InsentiveCompletelist)
      } else {
        this.InsentivePendinglist;
        console.log('InsentivePendinglist',this.InsentivePendinglist)
      }
  }

  monthdatalowecase;
  downloadIncentiveDetailsdata() {
      this.masterIncentiveMonth;
      this.monthdatalowecase = this.masterIncentiveMonth.toLowerCase();
      const incentiveMonthdata = this.monthdatalowecase.replace(/ /g,"_");
      this.financeService.downloadIncentiveMonthDetails(incentiveMonthdata).subscribe(res =>{
      console.log('res',res);
      this.headers_res= res.headers._headers;
      res= res.json();
      console.log('res json', res.champion_monthly_incentive_report);
      window.open(res.champion_monthly_incentive_report, '_blank');
      var dataaaa = res.champion_monthly_incentive_report;
      console.log('download list',dataaaa);
    });
  }


  championid;
  filterColumDropdownChange1(championid){ 
    console.log('pending filter on chnage on dropdown');
    console.log('championid',championid)
    this.championid = championid;
  }

  filterData(){
    console.log('pending filter');
    this.getChampionIncentivePendingList(1,this.championid);
  }

  filterColumDropdownChange2(championid){ 
    console.log('complete filter on change')
    console.log('championid',championid)
    this.championid = championid;
  }

  filterData2(){
   console.log('complete filter');
    this.getChampionInsentivePaidlist(1,this.championid);
  }




  hidecheckbox:boolean = true;
  getChampionIncentivePendingList(page, userid='') {
    console.log('championid',userid);
    this.financeService.getPendingIncentiveMonthList(this.masterIncentiveMonth,page,'',userid).subscribe(res =>{
      this.headers_res= res.headers._headers;
      res= res.json();
      if(this.pendingStatus === 'pending') {
        // this.hidecheckbox = true;
        this.InsentivePendinglist = res.champion_pending_monthly_incentive_detail;
        this.monthlyIncentiveListData = this.InsentivePendinglist;
        console.log('Pending incentive data', this.monthlyIncentiveListData);
      }
      this.total_records = res.total_records;
      this.per_page = res.limit;
      this.InsentivePendinglist_totalPage = this.total_records
      console.log('total_records, page_limit - Pending list---->>>', this.total_records, this.per_page);
    });
  }

  getChampionInsentivePaidlist(page,userid) {
    console.log('page no', page,userid);
    this.financeService.getPaidIncentiveMonthList(this.masterIncentiveMonth,page,'',userid).subscribe(res =>{
      this.headers_res= res.headers._headers;
      res= res.json();
      if(this.releasedStatus === 'released') {
        // this.hidecheckbox = false;
        this.InsentiveCompletelist = res.champion_paid_monthly_incentive_detail;
        this.monthlyIncentiveListData = this.InsentiveCompletelist;
        console.log('Compelet incentive data', this.monthlyIncentiveListData);
      }
      this.total_records = res.total_records;
      this.InsentiveCompletelist_totalPage = res.total_records;
      this.per_page = res.limit;
      console.log('total_records, page_limit - complete list--->>', this.total_records, this.per_page);
    });
  }

  changeProjectStatus(status) {
    console.log('changeProjectStatus',status)
    this.currentProjectStatus=status;
    this.loaderService.display(true);
    if(status === 'pending') {
      console.log('pending Status',this.pendingStatus);
      this.hidecheckbox = !this.hidecheckbox;
      this.loaderService.display(false);
      this.getChampionIncentivePendingList(1,'');
    } else {
      console.log('released status');
      this.hidecheckbox = !this.hidecheckbox;
      this.loaderService.display(false);
      this.getChampionInsentivePaidlist(1, '');
    }
  }

  UserIdCheckbox: number;
  useridarray = [];
  isSelected = false;
  isAllSelected(id, event: any, isSelected) {
    this.isSelected = false
    if (event.target.checked) {

      this.useridarray.push(id);
      this.useridarray = this.useridarray.filter((element, i) => i === this.useridarray.indexOf(element))
      console.log('unique user id one by one', this.useridarray);

    } else {
      $("#allcheckid").prop('checked', false);
      for (var i = 0; i < this.InsentivePendinglist.length; i++) {
        if (this.useridarray[i] == id) {
          this.useridarray.splice(i, 1);
          console.log('useridarray', this.useridarray);
        }
      }
    }
  }

  selectAll(event) {
    console.log('event select all',event);
      this.InsentivePendinglist.forEach((data,index) => {
        if(event.target.checked) {
          if(data.user_id) {
            this.useridarray.push(data.user_id);
            this.useridarray = this.useridarray.filter((element, i) => i === this.useridarray.indexOf(element))
            console.log('unique user id in select all',this.useridarray);
            setTimeout(() => {
              $("#idvalue-"+index).prop('checked',true);
            }, 500)
          } 
        } else {
          $("#idvalue-"+index).prop('checked',false);
          this.useridarray = [];
        }
    });
  }

 
  paidCheckBox() {
    console.log('click successfully - paid btn');
    const userId = this.useridarray;
    console.log('const userId', userId);
    this.monthdatalowecase = this.masterIncentiveMonth.toLowerCase();
    const incentiveMonthdata = this.monthdatalowecase.replace(/ /g,"_");
    if(userId.length > 0){
      this.financeService.checkUnCheck(userId,incentiveMonthdata).subscribe(res => {
        this.headers_res = res.headers._headers;
        console.log('headers_res', this.headers_res);
        res = res.json();
        console.log('res', res);
        this.successalert = true;
        this.successMessage = res.message;
        this.getChampionIncentivePendingList(1,'');
        this.getChampionInsentivePaidlist(1,'');
        this.changeProjectStatus(this.releasedStatus);
        setTimeout(function() {
              this.successalert = false;
        }.bind(this), 2000);
  
      }, error => {
        this.errorMessage = error;
        this.errorMessage = JSON.parse(this.errorMessage['_body']).errors;
        setTimeout(function () {
          this.erroralert = false;
        }.bind(this), 5000);
      });
    }else{
      alert('Please select atleast one item from the list');
    }
  }





}



// WEBPACK FOOTER //
// ./src/app/platform/finance/view-champion-incentive/view-champion-incentive.component.ts